import React, {useState, useEffect} from 'react';

const Phone = ({children}) => {
  const [init, setInit] = useState(false);
  useEffect(() => {
    setInit(true);
  }, []);
  if (init === false) {
    return null;
  }
  return (
    <a
      href={`tel:+${children
        .replace(
          /(\d{2})\.{0,1}(\d{2})\.{0,1}(\d{2})\.{0,1}(\d{2})\.{0,1}(\d{2})/,
          '$1$2$3$4$5',
        )
        .replace('0', '33')}`}
    >
      {children.replace(
        /(\d{2})\.{0,1}(\d{2})\.{0,1}(\d{2})\.{0,1}(\d{2})\.{0,1}(\d{2})/,
        '$1 $2 $3 $4 $5',
      )}
    </a>
  );
};

export default Phone;
